// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bp-0";
export var orangeButton = "_bp-1";